import React from 'react'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const Phone = ({name, index, title, value, placeholder, validate, change}) => {
  return (
    <React.Fragment>
      <label htmlFor={`${name}-field-${index}`} className="block text-sm font-semibold text-red mb-5">{title}{ validate && validate.required ? ' *' : '' }</label>
      <PhoneInput
        id={`${name}-field-${index}`}
        value={value || null}
        defaultCountry="NO"
        international={false}
        className="text-input w-full max-w-sm2 border rounded-md border-grey-darker h-18 px-6 md:text-lg text-sm font-medium text-black flex items-center"
        placeholder={placeholder}
        name={name}
        onChange={ val => change(index, val)} />
    </React.Fragment>
  )
}

export default Phone
